import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/website/src/components/shared/next-link.tsx");
